module.exports = {
  attachments: {
    size_limit: 'The maximum file size is 10MB',
    count_limit: 'You can only upload up to 10 files with your comment',
    load_more: 'Load one more image | Load {count} more images',
  },
  commentPlaceholder: 'Comment...',
  comments: 'Comments',
  comment_is_sending: 'Your comment is being sent...',
  comment_is_added: 'Your comment was added',
  delete_comment: 'Delete comment',
  delete_comment_question: 'Delete comment?',
  deleteAnswer: {
    title: 'Delete answer?',
    confirmation: 'This answer and its replies will be permanently deleted. You cannot undo this operation.',
    typeDelete: 'Type DELETE to confirm.',
    success: 'Answer deleted.',
    error: 'Could not delete answer. Please try again later.',
  },
  deleted_by_admin: 'Comment deleted by administration.',
  deleted_by_user: 'Comment deleted by user.',
  deletion_failed: 'Could not delete comment, please try again later.',
  deletion_is_irreversible: 'You cannot undo this operation.',
  deletion_success: 'Your comment has been deleted.',
  messages_to_course_management: 'Messages to course management',
  more_replies: 'more reply | more replies',
  no_comments_yet: 'There are no comments yet.',
  no_messages_yet: 'There are no messages yet.',
  posting_failed: 'Could not post comment, please try again later.',
  read_more: 'read more',
  reply_to_x: 'Reply to %{username}',
  report_comment: 'Report comment',
  reporting_failed: 'Could not report comment, please try again later.',
  reporting_success: 'Your report has been sent.',
  report_reasons: {
    reason_offensive: 'Offensive Content',
    reason_advertisement: 'Spam / Advertisement',
    reason_personal_rights: 'Violation of Personal Rights',
    reason_misc: 'Other Reason',
  },
  upload_file: 'Upload file',
  usersCommented: 'has commented | have commented',
  vips: {
    coursemanager: 'Course Trainer',
  },
  write_comment: 'Write comment',
  write_comment_placeholder: 'Write comment…',
  write_message: 'Write message',
  write_reply: 'Write reply',
  reply: 'Reply',
  translate: 'Translate',
  approveReply: 'Helpful reply',
  approveReplyShort: 'Helpful',
  approvedReply: 'Approved answer',
  helpfulReply: 'Helpful',
  helpfulAnswers: 'Helpful answers',
  replyPlaceholder: 'Write a reply...',
  submit: 'Submit',
  loadingComments: 'Loading comments...',
  errorLoadingComments: 'Failed to load comments. Please try again.',
  noComments: 'No comments yet',
  beFirstToComment: 'Be the first to comment!',
  loadMore: 'Load more comments',
  loading: 'Loading...',
  cancelReply: 'Cancel reply',
  showOriginal: 'Show original',
  translatedFrom: 'Translated from {language}:',
  verifiedMessage: 'An admin has verified this response',
}
